// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_RepassesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/receita/repasses
 *
 * Recebimentos linked (via origem compromisso -> compromissos_servicos
 * -> orcamentos_servicos -> config_servicos) to service categories
 * marked as "repasse-eligible" (servicoscategoria_id IN (4, 5)).
 *
 * `items` is grouped by (servicoscategoria_id, servico_id) and sorted
 * by `recebido_bruto` DESC, then `servicoscategoria_nome` ASC,
 * then `servico_nome` ASC.
 */
import type { Receita_RepasseRow } from './Receita_RepasseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Receita_RepassesResponseDados {
items: Receita_RepasseRow[]
total_recebido_bruto: number
total_recebido_liquido: number
}

export type Receita_RepassesResponse = ApiResponse<Receita_RepassesResponseDados>;

registerResponseContract('Receita_RepassesResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      servicoscategoria_id:   { type: 'number',  required: false },
      servicoscategoria_nome: { type: 'string',  required: false },
      servico_id:             { type: 'number',  required: false },
      servico_nome:           { type: 'string',  required: false },
      recebido_bruto:         { type: 'number',  required: false },
      recebido_liquido:       { type: 'number',  required: false },
      count_recebimentos:     { type: 'number',  required: false },
    },
  },
  total_recebido_bruto:   { type: 'number',  required: true },
  total_recebido_liquido: { type: 'number',  required: true },
})
